<template>
	<!--图片信息-->
	<section class="photo-info publish-main">
		<el-form ref="form" :model="form" size="small" :rules="rules">
			<title-area title="图标素材" hint="要求：1.等边矩形；2.PNG、JPG；3.尺寸≧512px；4.不超过1M">
				<el-form-item prop="icolist">
					<div class="photo-upload-wrap">
						<div class="file_box" :style="{backgroundImage : 'url('+ fileImg + ')'}">
							<form id="subform" enctype="multipart/form-data" method="post" action="/zklccloud/uploadImages">
								<input type="file" name="file" id="uploadImage" :class="{'vis-hide': classVisFlag}" @change="uploadImage()" @click="disabledF" :disabled="hidsubv">
								<input type="hidden" name="type" value="2">
							</form>
						</div>
					</div>
					<ul class="photo-size">
						<li class="items">
							<section class="size" style="width: 128px;height: 128px;">
								<img class="img" :src="images128" />
							</section>
							<section class="title color_9">128 x 128</section>
						</li>
						<li class="items">
							<section class="size" style="width: 72px;height: 72px;">
								<img class="img" :src="images72" />
							</section>
							<section class="title color_9">72 x 72</section>
						</li>
						<li class="items">
							<section class="size" style="width: 64px;height: 64px;">
								<img class="img" :src="images64" />
							</section>
							<section class="title color_9">64 x 64</section>
						</li>
						<li class="items">
							<section class="size" style="width: 32px;height: 32px;">
								<img class="img" :src="images32" />
							</section>
							<section class="title color_9">32 x 32</section>
						</li>
					</ul>
					<ul class="number-size">
						<li>更多尺寸：</li>
						<li class="items" v-for="icon in form.icolist" v-if="icon.viewSize !=32 && icon.viewSize !=64 && icon.viewSize !=72 && icon.viewSize != 128">{{icon.viewSize}}*{{icon.viewSize}}</li>
					</ul>
				</el-form-item>
			</title-area>

			<title-area title="应用截图" hint="请上传2-5张图片，大于500px，格式PNG\JPG， 2M以内大小" :margin-left="5" :dashed="false">
				<el-form-item prop="paths">
					<div class="screenshot_container">
						<div class="container-fluid">
							<div class="row publick_form_box">
								<div class="img_box pos-relative" v-for="(path,index) in form.paths" v-show="form.paths.length!=0" :disabled="hidsubv">
									<img v-bind:src="path" />
									<i class="glyphicon ico_del" @click="delImg(index)" v-if="!hidsubv"></i>
								</div>
								<div class="file_box" v-show="form.paths.length<=4" :disabled="hidsubv">
									<form>
										<input type="file" name="file" id="addAppImage" @change="addAppImage($event)" :disabled="hidsubv" />
									</form>
								</div>
							</div>
						</div>
					</div>
				</el-form-item>
			</title-area>
		</el-form>
	</section>
</template>

<script>
	import { MessageBox } from 'element-ui'
	import titleArea from './title_area'
	export default {
		name: 'vPhotoInfo',

		data() {
			var validateIcolist = (rule, value, callback) => {
				if(this.form.icolist.length < 1) {
					callback(new Error('请上传图标素材'));
				} else {
					callback();
				}
			};
			var validatePaths = (rule, value, callback) => {
				if(this.form.paths.length < 2) {
					callback(new Error('请上传2-5张图片，大于500px，格式PNG\JPG， 2M以内大小'));
				} else {
					callback();
				}
			};
			return {
				imageUrl: '',
				hid: false,
				hidsub: false,
				hidsubv: false,
				fileImg: require('../../../assets/images/ico-add.png'),
				classVisFlag: false,
				form: {
					paths: [],
					icolist: [],
				},
				images128: require('../../../assets/images/img-default.png'),
				images72: require('../../../assets/images/img-default.png'),
				images64: require('../../../assets/images/img-default.png'),
				images32: require('../../../assets/images/img-default.png'),
				rules: { //表单的验证规则
					icolist: [
						{ required: true, message: '图标素材', trigger: 'change' }, { validator: validateIcolist, trigger: 'change' },
					],
					paths: [
						{ required: true, message: '应用截图', trigger: 'change' }, { validator: validatePaths, trigger: 'change' },
					],
				},
			}
		},

		components: {
			titleArea,
		},

		mounted: function() {
			this.$nextTick(function() {
              var tempAppFiles = this.$parent.appFiles;
              this.hid = this.$parent.hid;
			  this.hidsub = this.$parent.hidsub;
			  this.hidsubv = this.$parent.hidsubv;
              var temp = this;
              if(0 != tempAppFiles.length && '' != tempAppFiles[0])
              {
              	for(var i = 0; i < tempAppFiles.length; i++) 
              	{
					if(tempAppFiles[i].fileType == '108001') {
						temp.form.icolist.push(tempAppFiles[i]);
						temp.fileImg = tempAppFiles[0].filePath;
						if(tempAppFiles[i].viewSize == '128') {
							temp.images128 = tempAppFiles[i].filePath
						}
						if(tempAppFiles[i].viewSize == '72') {
							temp.images72 = tempAppFiles[i].filePath
						}
						if(tempAppFiles[i].viewSize == '64') {
							temp.images64 = tempAppFiles[i].filePath
						}
						if(tempAppFiles[i].viewSize == '32') {
							temp.images32 = tempAppFiles[i].filePath
						}
					} else {
						temp.form.paths.push(tempAppFiles[i].filePath);
					}
				}
              }
			})
		},
		props: {
			data: {}
		},

		methods: {
			handleAvatarSuccess(res, file) {
				this.imageUrl = URL.createObjectURL(file.raw);
			},

			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;

				if(!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
				}
				if(!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},

			//上传图标 ↓
			uploadImage: function(e) {
				e = e || window.event;
				var temp = this;
				$("#subform").ajaxSubmit(function(data) {
					if(data.resultCode == '0') {
						MessageBox('操作成功！', '提示', 'success', {
							confirmButtonText: '确定',
						});
						temp.form.icolist = [];
						temp.form.icolist = data.content.filepath;
						temp.fileImg = temp.form.icolist[0].filePath;
						temp.classVisFlag = false;
						for(var i = 0; i < temp.form.icolist.length; i++) {
							if(temp.form.icolist[i].viewSize == '128') {
								temp.images128 = temp.form.icolist[i].filePath
							}
							if(temp.form.icolist[i].viewSize == '72') {
								temp.images72 = temp.form.icolist[i].filePath
							}
							if(temp.form.icolist[i].viewSize == '64') {
								temp.images64 = temp.form.icolist[i].filePath
							}
							if(temp.form.icolist[i].viewSize == '32') {
								temp.images32 = temp.form.icolist[i].filePath
							}
						}
					} else {
						temp.classVisFlag = false;
						if(data.content.filepath == "#nottype#") {
							MessageBox('操作失败，请检查附件大小和类型！', '提示', 'warning', {
								confirmButtonText: '确定',
							});
						} else {
							MessageBox('操作失败，请上传等边矩形且尺寸>=512的图片！', '提示', 'warning', {
								confirmButtonText: '确定',
							});
						}
					}
				});
			},

			disabledF() {
				this.classVisFlag = true;
				var temp = this;
				setTimeout(function() {
					temp.classVisFlag = false;
				}, 2000)
			},

			//上传截图 ↓
			addAppImage(e) {
				e = e || window.event;
				var temp = this;
				var fileObj = e.target.files || e.dataTransfer.files; // js 获取文件对象
				var FileController = '/zklccloud/uploadImages'; // 接收上传文件的后台地址
				// FormData 对象
				var form = new FormData();
				form.append("file", fileObj[0]); // 文件对象
				form.append("type", "1");
				var xhr = new XMLHttpRequest();
				xhr.open("post", FileController, true);
				xhr.onload = function() {
					var ttt = eval('(' + xhr.responseText + ')');
					if(ttt.resultCode == '0') {
						temp.form.paths.push(ttt.content.filepath);
					} else {
						MessageBox('操作失败，请检查附件大小和类型！', '提示', 'warning', {
							confirmButtonText: '确定',
						});
					}
				};
				xhr.send(form);
			},
			delImg: function(index) {
				this.form.paths.splice(index, 1)
			},
			verify() { //form表单的校验结果
				let flag;
				this.$refs['form'].validate((valid) => {
					if(valid) {
						flag = true;
					} else {
						console.log('error submit!!');
						flag = false;
						return false;
					}
				});
				if(flag) {
					return {
						flag: flag,
						status: 4,
						form: this.form
					};
				}
			},
			saveverify() { //form表单的校验结果
				return {
					flag: true,
					status: 4,
					form: this.form
				};
			},
		}
	}
</script>

<style scoped>
	.photo-upload-wrap {
		margin-right: 60px;
		margin-bottom: 15px;
	}
	
	.photo-upload-wrap,
	.photo-size,
	.number-size {
		display: inline-block;
		margin-bottom: 0;
	}
	
	.photo-size {
		vertical-align: bottom;
		margin-right: 50px;
	}
	
	.number-size {
		vertical-align: top;
	}
	
	.number-size .items {
		color: #252a3d;
	}
	
	.photo-size {
		font-size: 0;
	}
	
	.photo-size .items {
		font-size: 14px;
		display: inline-block;
		margin-right: 25px;
		text-align: center;
	}
	
	.photo-size .items .size {
		background-color: #dbdbdb;
	}
	
	.photo-size .items .size .img {
		width: 100%;
		height: 100%;
	}
</style>

<style>
	.photo-upload-wrap {
		display: inline-block;
	}
	
	.photo-upload-wrap .avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	
	.photo-upload-wrap .avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}
	
	.photo-upload-wrap .avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 138px;
		height: 138px;
		line-height: 138px;
		text-align: center;
	}
	
	.photo-upload-wrap .avatar {
		width: 138px;
		height: 138px;
		display: block;
	}
</style>


// WEBPACK FOOTER //
// photo_info.vue?404457b2